import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import WebService from "../../utility/WebService";
import AddUsWebinarSeries from "./AddUsWebinarSeries";
import AddWebinar from "./AddWebinar";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";

const UsWebinarSeries = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [data, setData] = useState<any>(null);
    const [isLoading, setLoading] = useState(false);
    const [webinars, setWebinars] = useState<any[]>([]);
    const [selectedWebinar, setSelectedWebinar] = useState<any>(null);
    const [selectedWebinarId, setSelectedWebinarId] = useState<string | null>(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        getData();
        getWebinars()
    }, [])

    const getData = () => {
        setLoading(true);
        WebService.getAPI({
            action: `us-webinar-series/getContent`,
        })
            .then((res: any) => {
                setData(res.data);
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    }

    const getWebinars = () => {
        WebService.getAPI({
            action: `webinar/get-webinar`,
        })
            .then((res: any) => {
                setWebinars(res.data);
            })
            .catch((err: any) => {
                console.error(err);
            });
    }

    return (
        <>
            <AddUsWebinarSeries
                show={showAddModal}
                handleClose={() => {
                    setShowAddModal(false);
                    getData();
                }}
                data={data}
            />
            <AddWebinar
                show={showAddModal}
                handleClose={() => {
                    setShowAddModal(false);
                    getWebinars();
                    setSelectedWebinar(null);
                }}
                data={selectedWebinar}
            />
            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onDelete={() => {
                    if (selectedWebinarId) {
                        WebService.deleteAPI({
                            action: `webinar/delete-webinar/${selectedWebinarId}`,
                        }).then(() => {
                            setShowDeleteModal(false);
                            getWebinars();
                        });
                    }
                }}
                message="Are you sure you want to delete this webinar?"
            />
            <div className="events-main">
                <Card className='event-card'>
                    {
                        isLoading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 100 }}>
                                <span className="spinner-border" role="status" aria-hidden="true"></span>
                            </div>
                        ) :
                            <>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div className='page-title'>US DOE IESA Webinar Series</div>
                                    <div className="d-flex gap-2">
                                        <CustomButton
                                            isLoading={false}
                                            label={'Add Webinar'}
                                            onClick={() => {
                                                setShowAddModal(true);
                                            }}
                                            style={{ width: 130 }}
                                        />
                                        <CustomButton
                                            isLoading={false}
                                            label={data ? 'Edit' : 'Add'}
                                            onClick={() => {
                                                setShowAddModal(true);
                                            }}
                                            style={{ width: 100 }}
                                        />
                                    </div>
                                </div>
                                {
                                    data == null ?
                                        <div className="text-center my-5">No data found</div>
                                        :
                                        <>
                                            {data.logo && <img src={data.logo} alt="Logo" width={350} />}
                                            {data?.title && <div className="mt-2"><strong>Title</strong></div>}
                                            {data?.title && <div className="font-14">{data?.title}</div>}
                                            {data?.description && <div className="mt-2"><strong>Description</strong></div>}
                                            {data?.description && <div className="font-14" dangerouslySetInnerHTML={{ __html: data?.description }} />}
                                            {data?.overview && <div className="mt-2"><strong>Overview</strong></div>}
                                            {data?.overview && <div className="font-14" dangerouslySetInnerHTML={{ __html: data?.overview }} />}
                                            {data?.seminarDate && <div className="mt-2"><strong>Seminar Date</strong></div>}
                                            {data?.seminarDate && <div className="font-14">{new Date(data?.seminarDate).toLocaleDateString()}</div>}
                                            {data?.structure && <div className="mt-2"><strong>Structure</strong></div>}
                                            {data?.structure && <div className="font-14" dangerouslySetInnerHTML={{ __html: data?.structure }} />}
                                            {data?.link && <div className="mt-2"><strong>Link</strong></div>}
                                            {data?.link && <div className="font-14">{data?.link}</div>}
                                            {data?.keyParticipants && <div className="mt-2"><strong>Key Participants</strong></div>}
                                            {data?.keyParticipants && <div className="font-14" dangerouslySetInnerHTML={{ __html: data?.keyParticipants }} />}
                                            {data?.topic && <div className="mt-2"><strong>Topic</strong></div>}
                                            {data?.topic && <div className="font-14" dangerouslySetInnerHTML={{ __html: data?.topic }} />}
                                            {data?.webinarImage && <div className="mt-2"><strong>Webinar Image</strong></div>}
                                            {data?.webinarImage && <div className="font-14"><img src={data?.webinarImage} alt="Webinar" style={{ maxWidth: "100%", maxHeight: 200, objectFit: "contain" }} /></div>}
                                            {data?.potentialTopic && data?.potentialTopic.length > 0 && <div className="mt-2"><strong>Potential Topics</strong></div>}
                                            {data?.potentialTopic && data?.potentialTopic.length > 0 && data?.potentialTopic.map((topic: any, index: number) => (
                                                <div>
                                                    <div key={index} className="font-14">{topic?.title}</div>
                                                    <div className="font-14" dangerouslySetInnerHTML={{ __html: topic?.description }} />
                                                </div>
                                            ))}
                                            {data?.keyMembers && data?.keyMembers.length > 0 && <div className="mt-2"><strong>Key Members</strong></div>}
                                            {data?.keyMembers && data?.keyMembers.length > 0 && data?.keyMembers.map((member: string, index: number) => (
                                                <img key={index} src={member} alt={`Member ${index + 1}`} width={150} style={{ border: '1px solid #ccc', padding: 2, marginRight: 10, marginBottom: 10 }} />
                                            ))}
                                            {webinars && webinars.length > 0 && <div className="mt-4"><strong>Webinars</strong></div>}
                                            {webinars && webinars.length > 0 && webinars.map((webinar: any, index: number) => (
                                                <div key={index} className="border p-3 my-2">
                                                    <div className="d-flex justify-content-end">
                                                        <PencilFill
                                                            className="me-3 cursor-pointer"
                                                            onClick={() => {
                                                                setShowAddModal(true);
                                                                setSelectedWebinar(webinar);
                                                            }}
                                                            title="Edit"
                                                        />
                                                        <TrashFill
                                                            color="#DC143C"
                                                            className="cursor-pointer"
                                                            onClick={() => {
                                                                setSelectedWebinarId(webinar._id);
                                                                setShowDeleteModal(true);
                                                            }}
                                                            title="Delete"
                                                        />
                                                    </div>
                                                    {webinar?.title && <div><strong>Title:</strong> {webinar?.title}</div>}
                                                    {webinar?.date && <div><strong>Date:</strong> {new Date(webinar?.date).toLocaleDateString()}</div>}
                                                    {webinar?.time && <div><strong>Time:</strong> {webinar?.time}</div>}
                                                    {webinar?.duration && <div><strong>Duration:</strong> {webinar?.duration}</div>}
                                                    {webinar?.topicForDiscussion && <div><strong>Topic For Discussion:</strong> <div dangerouslySetInnerHTML={{ __html: webinar?.topicForDiscussion }} /></div>}
                                                    {webinar?.structure && <div><strong>Structure:</strong> <div dangerouslySetInnerHTML={{ __html: webinar?.structure }} /></div>}
                                                    {webinar?.buttonText && <div><strong>Button Text:</strong> {webinar?.buttonText}</div>}
                                                    {webinar?.link && <div><strong>Link:</strong> {webinar?.link}</div>}
                                                </div>
                                            ))}
                                        </>
                                }
                            </>
                    }
                </Card>
            </div>
        </>
    )
}

export default UsWebinarSeries;